// Calculates VAT on a total and shows the total with VAT

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["input", "output"];

    connect() {
        // console.log("VAT Calculator connected");
        this.outputTarget.textContent = '';
    }

    calculate(event) {
        if (isNaN(this.inputTarget.value)) {
            console.error("Input value is not a valid number");
            this.outputTarget.textContent = "Input is not a number"
        } else {
        const value = parseFloat(this.inputTarget.value) || 0;
        const vatRate = 0.20;
        const total = value + value * vatRate;
        const formatter = new Intl.NumberFormat('en-GB', {style: 'currency', currency: 'GBP'});
        this.outputTarget.textContent = `Total incl VAT: ${formatter.format(total)}`;
        }
    }

}
